import React from 'react'
import { connect } from 'react-redux'
import { LineupsLoader } from 'loaders'
import PropTypes from 'prop-types'
import MatchDashboardLayout from './MatchDashboardLayout'

const MatchDashboardContainer = ({ currentMatch }) => {
  return (
    <>
      {currentMatch && (
        <LineupsLoader>
          <MatchDashboardLayout />
        </LineupsLoader>
      )}
    </>
  )
}
MatchDashboardContainer.defaultProps = {
  currentMatch: null,
}

MatchDashboardContainer.propTypes = {
  currentMatch: PropTypes.shape({}),
}

export default connect(
  ({ matches: { current } }) => ({
    currentMatch: current,
  }),
  {}
)(MatchDashboardContainer)
